import stylesheet0 from "common/reset";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".ax-tag" + shadowSelector + " {--axds-ovr-button-primary-hue: var(--sds-g-color-palette-blue-90);--axds-ovr-button-tertiary-hue: var(--sds-g-color-palette-blue-20);--axds-ovr-button-hover-color: var(--sds-g-color-palette-blue-80);--axds-ovr-button-active-color: var(--sds-g-color-palette-blue-80);--axds-ovr-button-disabled-text-color: var(--sds-g-color-palette-neutral-50);--axds-ovr-button-disabled-color: var(--sds-g-color-palette-neutral-90);}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet];